import * as React from "react";
import cardStyles from "./Card.module.scss";
import ComponentTheme from "../../../styles/componentTheme";

export default function Card({children, theme = null}) {
    const finalTheme = new ComponentTheme(cardStyles, theme);

    return <div className={finalTheme.defaultStyles}>{children}</div>;
}
